<template>
  <div>
    <div
      :id="id"
      :option="option"
      :obj="chartObj"
    />
  </div>
</template>
<script>
import HighCharts from 'highcharts'
import Wordcloud from 'highcharts/modules/wordcloud'

Wordcloud(HighCharts)
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      chartObj: {}
    }
  },
  watch: {
    option () {
      if (this.id && this.option) {
        this.chartObj = HighCharts.chart(this.id, this.option)
      }
    }
  },
  mounted () {
    if (this.id && this.option && HighCharts) {
      this.chartObj = HighCharts.chart(this.id, this.option)
    }
  }
}
</script>
